module.exports = __webpack_public_path__ + "ipad-border.a5b54b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/DeveloperIntegration/iFrame/ipad-border.png
// module id = 2997
// module chunks = 0